module.exports = __webpack_public_path__ + "media/images/arrow-down-country-ef808bd72c2fbedf162b05f13d60d8b8.svg";